import React from 'react'

function LawyerDashData( { data }) {

    console.log( "Data en LawyerDashData = " , data.lawyer )

  return (
    
            <>
           
            <div className='row mt-0'>

                <div className='col-sm-6'>

                    <p>El cliente {data.client?.client_name}</p>

                </div>

                <div className='col-sm-6'>
                    <p>Especialidad {data.lawyer?.especialidad}</p>
                </div>



            </div>

            <div className='row'>

                <div className='col-sm-12'>

                    <label htmlFor='comentario'></label>
                    <textarea className='form-control' readOnly id='comentario' rows='5' >{data.client?.comentario_express}</textarea>

                </div>

            </div>

            </>

        
  )
}

export default LawyerDashData